import React from 'react';
import SystemListNg from './SystemsListNg';
import CombinationsNg from './CombinationsNg';

function SystemDetailNg({ ticket, isActive }) {
    if (!isActive) {
        return null;
    }
    if (ticket.get('type') !== 'System') {
        return null;
    }

    return (
        <div className="system-detail">
            <SystemListNg systems={ticket.get('systems')} groups={ticket.get('groups')} />
            <CombinationsNg ticket={ticket} isActive={isActive} />
        </div>
    );
}

export default SystemDetailNg;
